module.exports = __webpack_public_path__ + "static/media/accessory__lightSensor.68d04adb.jpg";